import PropTypes from 'prop-types';
import React from 'react';
import SubHeader from '../../SubHeader.jsx';
import ReportResultsTable from './ReportResultsTable/index.jsx';
import { StakeholderIcon } from '../../icons/StakeholderIcon.jsx';

ReportGroupsResultsSection.propTypes = {
  title: PropTypes.node.isRequired,
  results: PropTypes.array.isRequired,
};

ReportGroupsResultsSection.defaultProps = {};

function ReportGroupsResultsSection({
  title,
  participantType,
  results,
  hasParentPortfolios,
}) {
  return (
    <section className="component-margin-top m-0">
      <SubHeader flex small>
        <h2 className="flex flex-align-center">
          {participantType === 'Stakeholder' && (
            <div className="m-r-8">
              <StakeholderIcon />
            </div>
          )}
          {title}
        </h2>
        <strong className="header-item bordered text-muted">
          Total:&nbsp;
          <span className="text-primary">{results.length}</span>
        </strong>
      </SubHeader>
      <ReportResultsTable
        results={results}
        hasParentPortfolios={hasParentPortfolios}
        participantType={participantType}
      />
    </section>
  );
}

export default ReportGroupsResultsSection;
